import React from "react";
import { Helmet } from "react-helmet-async";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import { Alert } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import { StyledBlockLabel, StyledFormBlock, StyledInputBlock } from "../../../styles/styledTabsForm";

const RatesDetailsInfo = ({ rate }) => {
  const { t } = useTranslation("ratesPage");

  if (!rate) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (rate.length === 0) {
    return <Alert severity="warning">{t("rates.details.changeForm.emptyData")}</Alert>;
  }

  return (
    <>
      <Helmet>
        <title>{t("rates.details.meta.title")} {rate.rateBase.currency.asset}/{rate.rateBase.service.name} • eXsoft.io</title>
      </Helmet>
      <StyledFormBlock>
        <StyledBlockLabel>
          {t("rates.details.changeForm.rate")}
        </StyledBlockLabel>
        <StyledInputBlock>
          <TextField
            className="grid-form__input"
            label={t("rates.details.changeForm.project")}
            type="text"
            value={rate.connection.project.name}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
          <TextField
            className="grid-form__input"
            label={t("rates.details.changeForm.currency")}
            type="text"
            value={rate.rateBase.currency.asset}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
          <TextField
            className="grid-form__input"
            label={t("rates.details.changeForm.selling")}
            type="text"
            value={rate.selling}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
          <TextField
            className="grid-form__input"
            label={t("rates.details.changeForm.purchase")}
            type="text"
            value={rate.purchase}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
          <TextField
            className="grid-form__input"
            label={t("rates.table.rateBaseService")}
            type="text"
            value={rate.rateBase.service.name}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
        </StyledInputBlock>
        <div className="clear-column" />
      </StyledFormBlock>
    </>
  );
};

export default RatesDetailsInfo;